import { lazy } from "react";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { EditProfileSection } from "./EditProfilePage/EditProfilePage";

const SettingsPage = lazy(() => import("./SettingsPage"));
const EditProfilePage = lazy(() => import("./EditProfilePage"));
const MainSettings = lazy(() => import("./MainSettings"));

export type SettingsPagesNavigationParams = {
  settingsMainSettings: PageNavParams;
  settingsSettings: PageNavParams;
  settingsEditProfile: PageNavParams<{ section: EditProfileSection }>;
};

export const settingsPagesNavigationConfig: ModulePagesConfig<SettingsPagesNavigationParams> =
  {
    settingsMainSettings: {
      element: <MainSettings />,
      path: "settings/main-settings",
      isPrivate: true,
      isActiveSubscriptionOptional: true,
    },
    settingsSettings: {
      element: <SettingsPage />,
      path: "settings",
      isPrivate: true,
      isActiveSubscriptionOptional: true,
    },
    settingsEditProfile: {
      element: <EditProfilePage />,
      path: "settings/edit-profile/:section",
      isPrivate: true,
      isActiveSubscriptionOptional: true,
    },
  };
